<template>
  <div>
    <div class="tit-box type2" v-if="begnDeNdctAt == 'Y'">
      <span>시행일:</span>
      <cd-selbx :cds="splts"
                :cd="spltSn"
                :cd-txt="'spltSn'"
                :nm-txt="'useBegnDe'"
                @select="selSpltSn_change"/>
    </div>
    <div v-html="cn"/>

  </div>


  <div style="text-align: center;">
    <btn :txt="'닫기'"
         :color="'gray'"
         :size="'middle'"
         @click="btnClose_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits, ref, onMounted} from 'vue';
import {getStore, getUtils} from "@/utils/import";
import CdSelbx from "@/components/cd-selbx.vue";

const {$axios, $cmmn} = getUtils();
const {$loading} = getStore();

const cn = ref('');
const props = defineProps({
  spltSecd: {
    type: String,
    default: '',
  },
  begnDeNdctAt: {
    type: String,
    default: 'N',
  }
});

const splts = ref([]);
const spltSn = ref(null);

const emits = defineEmits(['close']);
const btnClose_click = () => {
  emits('close');
};

const getSpltCn = async (spltSn) => {
  const {data} = await $axios.get('/api/cmmn/splt', {params: {spltSn}});
  cn.value = data ? data.spltCn : '';
};

const selSpltSn_change = async (selCd) => {
  try {
    $loading.on();

    spltSn.value = selCd;
    await getSpltCn(spltSn.value);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};

onMounted(async () => {
  try {
    $loading.on();

    const {data} = await $axios.get('/api/cmmn/splts', {params: {spltSecds: [props.spltSecd]}});
    splts.value = data.map(({spltSn, spltSecd, spltSecdNm, useBegnDe, useEndDe, spltCn}) => (
        {
          spltSn,
          spltSecd,
          spltSecdNm,
          useBegnDe: $cmmn.date.getYmdFormat(useBegnDe, '-'),
          useEndDe: $cmmn.date.getYmdFormat(useEndDe, '-'),
          spltCn,
        }
        ));
    spltSn.value = splts.value.length > 0 ? splts.value[0].spltSn : null;
    await getSpltCn(spltSn.value);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
